export default `{
  'id': _id,
  'type': _type,
  ...
}`;
